<div fxLayout="row">
  <div class="section-title">Location filters</div>
  <div fxFlex></div>
  <div class="actions">
    <lib-button [matMenuTriggerFor]="addCampaignMenu" icon="add">Add Location Filter</lib-button>
    <mat-menu #addCampaignMenu="matMenu">
      <button mat-menu-item (click)="onAddFilter_ByOrganizationId()">By Organization Id</button>
      <button mat-menu-item (click)="onAddFilter_ByOrganizationTag()">By Organization Tag</button>
      <button mat-menu-item (click)="onAddFilter_ByOutlet()">By Outlet</button>
      <button mat-menu-item (click)="onAddFilter_ByOutletProperty()">By Outlet Property</button>
    </mat-menu>
  </div>
</div>

<!-- HEADER -->
@if (model?.filters.length > 0) {
  <div fxLayout="row" style="margin-bottom: 30px;">
    <div fxLayout="row" fxLayoutAlign="start center" class="section-title">
      @for (filter of model?.filters; track filter; let ix = $index) {
        <div class="tab-item"
          [class.active]="currentView == ix"
          (click)="currentView = ix">
          @if (filter.type === LocFilterType.ByOrganizationId) {
            <span>Organisation locations</span>
          }
          @if (filter.type === LocFilterType.ByOrganizationTag) {
            <span>Organisations locations by tags</span>
          }
          @if (filter.type === LocFilterType.ByOutlet) {
            <span>Locations</span>
          }
          @if (filter.type === LocFilterType.ByOutletProperty) {
            <span>Locations by outlet property</span>
          }
        </div>
      }
    </div>
    <div fxFlex></div>
  </div>
}

@for (filter of model?.filters; track filter; let ix = $index) {
  <div [hidden]="!(currentView == ix)">
    @if (filter.type === LocFilterType.ByOrganizationId) {
      <app-filter-by-organization-id   [model]="filter" (deleteOrganisationId)="onDeleteOrganisationId($event)"></app-filter-by-organization-id>
    }
    @if (filter.type === LocFilterType.ByOrganizationTag) {
      <app-filter-by-organization-tag [model]="filter" (delete)="onDeleteFilter($event)"></app-filter-by-organization-tag>
    }
    @if (filter.type === LocFilterType.ByOutlet) {
      <app-filter-by-outlet                    [model]="filter" (deleteOutlet)="onDeleteOutlet($event)"></app-filter-by-outlet>
    }
    @if (filter.type === LocFilterType.ByOutletProperty) {
      <app-filter-by-outlet-property   [model]="filter" (delete)="onDeleteFilter($event)"></app-filter-by-outlet-property>
    }
  </div>
}

@if (model?.filters.length === 0) {
  <div>No campaign location filters</div>
}

<lib-loading-overlay [isLoading]="isLoading" [message]="'loading...'" />
